<div class="input-group" [formGroup]="formGroup">
    @if (prefixParam$ | ngrxPush; as prefixParam) {
        <ng-select
            [items]="prefixParam?.options"
            bindLabel="label"
            bindValue="value"
            [formControlName]="prefixParam?.code"
            [id]="prefixParam?.code"
            [searchable]="false"
            class="w-25"
        >
        </ng-select>
    }

    @for (
        param of activeParams$ | ngrxPush | keyvalue;
        track param.key;
        let i = $index
    ) {
        <clmi-workflow-designer-parameter-input
            [parameter]="param.value"
            [formGroup]="formGroup"
            [componentProvider]="componentProvider"
            [overrideValue]="param.value.getValue?.(formGroup)"
            [attr.class]="i === 0 ? 'w-50' : 'w-25'"
        />
    }
</div>
